/**
 * created by Yoyo Fang on 08/12/19
 * Description:
 *
 * ------ maintenance history ------
 */
import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[tamDashboardTileContainer]',
})
export class TamDashboardTileContainerDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
